import React, { useMemo } from "react"
import styled, { useTheme } from "~/ui/styled"
import { ColumnFlex, CenterFlex, Text } from "~components/El"
import { Avatar } from "~widgets/avatar"
import { AttachRedPacketData, RedpacketStatus } from "~proto"
import { PopupRoot, PopupImageBackground, PopupClose } from "../components/PopupShell"

const transferBg = require("~assets/images/chat/transfer_bg.png")

interface Props {
  redpacketData?: AttachRedPacketData
  onClose: () => void
}

const RedPacketDetailNoticePopup: React.FC<Props> = ({ redpacketData, onClose }) => {
  const theme = useTheme()
  const { sender_nickname, blessing_words, status } = redpacketData
  const grap_info = redpacketData?.grap_info.length > 0 ? redpacketData?.grap_info[0] : null

  const StatusDesc = useMemo(() => {
    if (status === RedpacketStatus.EXPIRED) {
      return "该红包已超过24小时"
    } else if (status === RedpacketStatus.REFUNDED) {
      return "该红包已超过24小时"
    } else if (status === RedpacketStatus.FINISHED) {
      if (redpacketData?.sender_nickname && redpacketData?.sender_nickname.includes("系统赔付")) {
        return "赔付完成"
      } else {
        return "已存入您的账户余额"
      }
    }
    return "该红包还没被领取"
  }, [status])

  return (
    <PopupRoot width="100%">
      <PopupImageBackground src={transferBg} resizeMode="cover">
        <ColumnFlex width="100%" height="100%" alignItems="center">
          <CenterFlex
            width="60px"
            height="60px"
            padding="2px"
            mt="60px"
            borderRadius="30px"
            bg={theme.colors.text}
          >
            <Avatar avatar={redpacketData?.sender_image} size={56} name={sender_nickname} />
          </CenterFlex>

          <Text mt="8px" fontSize={18} color={theme.colors.text} fontWeight="600">
            {sender_nickname || ""}的红包
          </Text>
          <CenterFlex height="auto" width="100%" padding="0 12px" mt="5px">
            <Text numberOfLines={2} fontSize={13} color={theme.colors.text}>
              {blessing_words || "恭喜发财，大吉大利"}
            </Text>
          </CenterFlex>

          <Text mt="15px" fontSize={40} color={theme.colors.error} fontWeight="600">
            ¥{grap_info.amount || "0"}
          </Text>
          <Text mt="5px" fontSize={10} color={theme.colors.secondary}>
            {StatusDesc}
          </Text>
        </ColumnFlex>
      </PopupImageBackground>
      <PopupClose onClose={onClose} />
    </PopupRoot>
  )
}

export default RedPacketDetailNoticePopup
